export default "__VITE_ASSET__80c18d7f__"